import React from 'react';
import Gallery from '../components/Gallery';
import { renovationsImages } from '../utils/imageUtils';

const Renovations: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Renovations</h1>
        <div className="prose max-w-none">
          <p className="text-lg text-gray-700 mb-6">
            Breathe new life into your space with our expert renovation services. From minor updates
            to complete transformations, we bring innovation and quality to every project.
          </p>
          <div className="mt-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-6">Our Renovation Projects</h2>
            <Gallery images={renovationsImages} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Renovations; 